module.exports = __webpack_public_path__ + "static/img/053.4616172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/053.png
// module id = t6JM
// module chunks = 0